module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "nav",
    class: {
      notTouchingSideNav: !_vm.touchingSideNav
    },
    style: ({
      webkitTransform: 'translateX(' + _vm.translateX + ')'
    }),
    on: {
      "transitionend": _vm.sendView
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.calName))])]), _vm._v(" "), _c('div', {
    staticClass: "nav-menu"
  }, [_c('ul', {
    staticClass: "nav-menu__list"
  }, [_c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue.public.app.sidenav.changeview')) + "\n          ")]), _vm._v(" "), _c('v-touch', {
    staticClass: "list-item",
    on: {
      "tap": function($event) {
        return _vm.setView(1)
      }
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue.public.app.sidenav.showday')))])]), _vm._v(" "), _c('v-touch', {
    staticClass: "list-item",
    on: {
      "tap": function($event) {
        return _vm.setView(3)
      }
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue.public.app.sidenav.showweek')))])]), _vm._v(" "), _c('v-touch', {
    staticClass: "list-item",
    on: {
      "tap": function($event) {
        return _vm.setView(2)
      }
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('vue.public.app.sidenav.showweekplan')))])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('repitition.chooselanguage')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "list-item"
  }, [_c('set-locale', {
    on: {
      "locale": _vm.emitLocale
    }
  })], 1)], 1)])]), _vm._v(" "), (_vm.menu) ? _c('v-touch', {
    on: {
      "panstart": _vm.onPanStart,
      "panend": _vm.onPanEnd,
      "pan": _vm.moveMenu,
      "tap": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "drag-target"
  })]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [(_vm.menu) ? _c('div', {
    staticClass: "nav-overlay"
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57b1d2c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/SideNav.vue
// module id = 1610
// module chunks = 1